import React from 'react';
import { useHits } from 'react-instantsearch';

const ToolCards = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { hits, sendEvent } = useHits(props);

    if (window.filtersInit) {
        document.getElementById('listing').scrollIntoView({behavior: 'instant'});
    } else {
        setTimeout(function() {
            window.filtersInit = true;
        }, 1000)
    }

    if (hits.length) {
        return (
            <section className="flex flex-col gap-6">
                {hits.map((hit) => (
                    <article key={hit.objectID} className="border border-grey-300 flex flex-col gap-6 p-4 md:flex-row md:items-center md:gap-8 md:p-8">
                        <div className="flex flex-1 gap-3 md:gap-8">
                            <div className="w-6 mt-1 sm:mt-1.5 md:mt-0 md:w-12">
                                <a data-event='{"category": "Downloads", "action": "Clicked Image", "label": "${ hit.title }"}'
                                    target={hit.buttonTarget} rel="nofollow noindex" href={hit.url}>
                                    <img className="w-full h-auto" src={hit.image} alt={hit.alt} aria-hidden="true"/>
                                </a>
                            </div>

                            <div className="flex-1">
                                <h2 className="font-bold text-lg md:text-xl">
                                    <a data-event='{"category": "Downloads", "action": "Clicked Title", "label": "${ hit.title }"}'
                                        target={hit.buttonTarget} rel="nofollow noindex" href={hit.url} className="underline underline-offset-2 decoration-transparent transition duration-300 ease-linear hover:decoration-black">
                                        {hit.title}
                                    </a>
                                </h2>
                                <div className="mt-2 prose text-sm">
                                    <p>{hit.copy}</p>
                                </div>
                            </div>
                        </div>

                        <div className="w-1/2 md:text-right md:w-auto">
                            <a data-event='{"category": "Downloads", "action": "Clicked Download", "label": "${ hit.title }"}'
                                data-spinner
                                target={hit.buttonTarget} rel="nofollow noindex" href={hit.url}
                                className="relative border rounded-sm text-center text-sm inline-flex items-center justify-center truncate w-full transition ease-linear duration-300 min-w-[120px] sm:w-auto md:text-[0.9375rem] lg:text-base bg-grey border-grey text-white hover:bg-green hover:border-green h-11 px-4 leading-snug">
                                <span className="button-text truncate">{hit.buttonLabel}</span>
                                <span
                                    className="button-spinner  mt-1.5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform hidden">
                                    <span className="spinner"></span>
                                </span>
                            </a>
                        </div>
                    </article>
                ))}
            </section>
        );
    } else {
        setTimeout(function() {
            document.getElementById('no-results')?.classList.remove('hidden');
        }, 500)

        return (
            <div id="no-results" className="border-2 border-grey-200 rounded p-6 sm:p-8 text-center max-w-screen-md mx-auto w-full hidden">
                <p className="font-bold text-green text-xl">{props.noresultsHeading}</p>
                <p className="text-sm md:text-base mt-2">{props.noresultsText}</p>
            </div>
        );
    }

}

export { ToolCards }
